import React, { Component } from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux'

import { furnitureScrollAuto } from '../../../services/script'
import { addToCart, addToWishlist, addToCompare } from "../../../actions/index";
import ProductItem from '../../layouts/common/product-item';
// import VisibilitySensor from "react-visibility-sensor";
class TopCollection extends Component {
    render() {
        const { items, symbol, addToCart, addToWishlistClicked, addToCompare, title, themeLayoutId, presentURL } = this.props;
        return (
            <div>


                {/* Fashion Theme & Beaty Theme */}

                {(themeLayoutId === "L01" || themeLayoutId === "L02"|| themeLayoutId === "L03") &&
                <>
                <div className="title1  section-t-space" style={{paddingTop:0}}>
                    {/* <h4>special offer</h4> */}
                    <h2 className="title-inner1">{title}</h2>
                </div>
                <section className="section-b-space p-t-0">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <Slider {...furnitureScrollAuto} className="product-4 product-m home-slider">
                                    {items.map((product, index) => {
                                        return (
                                            <div key={index}>
                                                <ProductItem product={product} symbol={symbol}
                                                    onAddToCompareClicked={() => addToCompare(product)}
                                                    onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                    onAddToCartClicked={() => addToCart(product, 1)} key={index}
                                                    themeLayoutId={themeLayoutId} 
                                                    presentURL = {presentURL}
                                                    />
                                            </div>
                                            )
                                    })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
                </>
            }
            {/* End Fashion Theme & Beaty Theme */}


            {/* Pet Theme Start */}

            {themeLayoutId === "L04" &&
                
            <section className="section-b-space j-box pets-box ratio_square">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="title1 title5">
                                <h2 className="title-inner1">SAVE AND EXTRA</h2>
                                <hr role="tournament6"/>
                            </div>
                            <Slider {...furnitureScrollAuto} className="product-4 product-m no-arrow">
                                {items.map((product, index) => {
                                    return (
                                        <div key={index}>
                                            <ProductItem product={product} symbol={symbol}
                                                onAddToCompareClicked={() => addToCompare(product)}
                                                onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                onAddToCartClicked={() => addToCart(product, 1)} key={index}
                                                themeLayoutId={themeLayoutId} 
                                                presentURL = {presentURL}
                                            />
                                        </div>)
                                })
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
            }

            {/* End Pet Theme */}

            {/* Kids Theme Start */}

            {(themeLayoutId === "L05") &&
                <>
                    <div>
                    <div className="title1  section-t-space">
                        <h4>special offer</h4>
                        <h2 className="title-inner1">top collection</h2>
                    </div>
                    <section className="section-b-space p-t-0">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                <Slider ref={topCollectionSlider => (this.topCollectionSlider = topCollectionSlider)} {...furnitureScrollAuto} className="product-4 product-m no-arrow">
                                    {items.map((product, index) => {
                                        return (
                                            <div key={index}>
                                                <ProductItem product={product} symbol={symbol}
                                                    onAddToCompareClicked={() => addToCompare(product)}
                                                    onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                    onAddToCartClicked={() => addToCart(product, 1)} key={index}
                                                    themeLayoutId={themeLayoutId} 
                                                    presentURL = {presentURL}
                                                />
                                            </div>)
                                    })
                                    }
                                </Slider>
                                </div>
                            </div>
                        </div>
                    </section>
                    </div>
                </>
            }
            {/* End Kids Theme */}



            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    // items: getTrendingCollection(state.data.products, ownProps.type),
    symbol: state.data.symbol,
    presentURL: state.tenant.presentURL,
})

export default connect(mapStateToProps, { addToCart, addToWishlist, addToCompare })(TopCollection);